<div class="container-fluid my-4">
  <div class="row mb-4 align-items-center">
    <div class="col-md-6">
      <h4 class="mb-0 text-primary fw-bold">Darpan Integration</h4>
    </div>
    <div class="col-md-6 text-end">
      <button class="btn btn-outline-secondary rounded-pill px-4" (click)="goBack()">
        <i class="bi bi-arrow-left me-1"></i> Go back to Dashboard
      </button>
    </div>
  </div>

  <div class="card shadow-sm border-0 mb-4 rounded-3">
    <div class="card-body p-4">
      <div class="row align-items-center">
        <div class="col-md-8">
          <h5 class="card-title fw-semibold">Preview Data</h5>
          <p class="card-text text-muted mb-0">Fetch the data that will be pushed to the Darpan portal to preview it below. Make sure to review the information before initiating the push.</p>
        </div>
        <div class="col-md-4 text-md-end mt-3 mt-md-0">
          <button class="btn btn-primary rounded-pill px-4 shadow-sm" (click)="fetchPushData()">
            <i class="bi bi-cloud-download me-2"></i> Fetch Push Data
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card shadow-sm border-0 rounded-3 animate__animated animate__fadeInUp" *ngIf="previewData && previewData.length > 0">
    <div class="card-header bg-white border-bottom-0 d-flex justify-content-between align-items-center py-3 px-4">
      <h5 class="mb-0 fw-semibold text-secondary">Data Preview</h5>
      <button class="btn btn-success rounded-pill px-4 shadow-sm" (click)="pushData()">
        <i class="bi bi-cloud-upload me-2"></i> Push to Darpan
      </button>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover table-striped mb-0 text-center align-middle">
          <thead class="table-light text-secondary">
            <tr>
              <th rowspan="2" class="align-middle border-end">State Code</th>
              <th rowspan="2" class="align-middle border-end">Division Code</th>
              <th rowspan="2" class="align-middle border-end">District Code</th>
              <th rowspan="2" class="align-middle border-end">Block Code</th>
              <th [attr.colspan]="financialYears.length * 2" class="border-bottom">KPI Data (Sanctioned & Completed by Year)</th>
            </tr>
            <tr>
              <ng-container *ngFor="let year of financialYears">
                <th class="fw-normal text-primary">Sanctioned ({{year}})</th>
                <th class="fw-normal text-success border-end">Completed ({{year}})</th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of previewData">
              <td class="border-end text-muted">{{item.state_code}}</td>
              <td class="border-end text-muted">{{item.division_code}}</td>
              <td class="border-end text-muted">{{item.district_code}}</td>
              <td class="border-end text-muted fw-bold">{{item.block_code}}</td>
              
              <ng-container *ngIf="financialYears.length > 0">
                <td class="text-primary fw-medium">{{item.kpi1_data}}</td>
                <td class="text-success fw-medium border-end">{{item.kpi2_data}}</td>
              </ng-container>
              <ng-container *ngIf="financialYears.length > 1">
                <td class="text-primary fw-medium">{{item.kpi3_data}}</td>
                <td class="text-success fw-medium border-end">{{item.kpi4_data}}</td>
              </ng-container>
              <ng-container *ngIf="financialYears.length > 2">
                <td class="text-primary fw-medium">{{item.kpi5_data}}</td>
                <td class="text-success fw-medium">{{item.kpi6_data}}</td>
              </ng-container>
            </tr>
          </tbody>
          <tfoot class="table-light fw-bold text-dark">
            <tr>
              <td colspan="4" class="text-end border-end pe-3">Grand Total</td>
              <ng-container *ngIf="financialYears.length > 0">
                <td class="text-primary">{{totals.kpi1_data}}</td>
                <td class="text-success border-end">{{totals.kpi2_data}}</td>
              </ng-container>
              <ng-container *ngIf="financialYears.length > 1">
                <td class="text-primary">{{totals.kpi3_data}}</td>
                <td class="text-success border-end">{{totals.kpi4_data}}</td>
              </ng-container>
              <ng-container *ngIf="financialYears.length > 2">
                <td class="text-primary">{{totals.kpi5_data}}</td>
                <td class="text-success">{{totals.kpi6_data}}</td>
              </ng-container>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
